import React from "react";
import "../index.css"
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";
import { useSelector } from "react-redux";

const Addresses = (props) =>{
    const { pmCompanyBillAddrDetails, buyerBillAddrDetails, buyerShipAddrDetails } = props

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    return(
        <div className="addresses">
            <div className="flex flex-row justify-content-between">
                <div className="p-card mb-1">
                    <h5 className="mb-1">Procmart Billing Address:</h5>
                    <div className="company-name">
                        {pmCompanyBillAddrDetails?.companyName}
                    </div>
                    <div className='address'>{pmCompanyBillAddrDetails?.billAddress}</div>
                    <div className='mt-2'>
                        <p>City: {pmCompanyBillAddrDetails?.city}</p>
                        <p>State: {pmCompanyBillAddrDetails?.stateName}</p>
                        <p>Pin Code : {pmCompanyBillAddrDetails?.pinCode}</p>
                        <p>State Code: {pmCompanyBillAddrDetails?.stateCode}</p>
                        <p>{pmCompanyConfig.GSTINLabel}: {pmCompanyBillAddrDetails?.gstinCode}</p>
                    </div>
                </div>
                <div className="p-card mb-1">
                <h5 className="mb-1">Buyer Billing Address:</h5>
                    <div className="company-name">
                        {buyerBillAddrDetails?.companyName}
                    </div>
                    <div className='address'>{buyerBillAddrDetails?.billAddress}</div>
                    <div className='mt-2'>
                        <p>City: {buyerBillAddrDetails?.city}</p>
                        <p>State: {buyerBillAddrDetails?.stateName}</p>
                        <p>Pin Code : {buyerBillAddrDetails?.pinCode}</p>
                        <p>State Code: {buyerBillAddrDetails?.stateCode}</p>
                        <p>{pmCompanyConfig.GSTINLabel}: {buyerBillAddrDetails?.gstinCode}</p>
                    </div>
                </div>
                <div className="p-card mb-1">
                <h5 className="mb-1">Buyer Shipping Address:</h5>
                    <div className="company-name">
                        {buyerShipAddrDetails?.companyName}
                    </div>
                    <div className='address'>{buyerShipAddrDetails?.shipAddr}</div>
                    <div className='mt-2'>
                        <p>City: {buyerShipAddrDetails?.city}</p>
                        <p>State: {buyerShipAddrDetails?.stateName}</p>
                        <p>Pin Code : {buyerShipAddrDetails?.pinCode}</p>
                        <p>State Code: {buyerShipAddrDetails?.stateCode}</p>
                        <p>{pmCompanyConfig.GSTINLabel}: {buyerShipAddrDetails?.gstinCode}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Addresses;